/**
 * API origin baked into the Vite bundle at build time.
 *
 * Production serves the web and API from separate subdomains, while an unset
 * value deliberately falls back to the current origin for proxy-based local
 * development.
 */
const configuredOrigin = import.meta.env.VITE_API_URL?.trim();

export const apiOrigin = configuredOrigin
  ? configuredOrigin.replace(/\/+$/, '')
  : window.location.origin;
